import TabPanel from 'client/components/GDS/Tabs/TabPanel/TabPanel';
import PropTypes from 'prop-types';
import {
    supplementaryDataTabAvailable
} from 'client/utils/helpers/SupplementaryData/SupplementaryDataUtils';
import {
    SupplementalLinkedFile
} from 'client/pages/MapPage/components/MapInteractions/SelectFeature/SelectFeaturePanel/SupplementaryDataTab/SupplementalLinkedFile';
import { useIntl } from 'react-intl';
import { SupplementalGuidance } from './SupplementalGuidance';

export const SupplementaryDataTab = ({ featureDetails, assetType, assetTypeId, ...props }) => {
    const isSupplementalTabVisible = supplementaryDataTabAvailable({ featureDetails });
    const intl = useIntl();
    return isSupplementalTabVisible
        ? <TabPanel {...props}>
            <div key={'linkedFiles'} data-testid={'linkedFiles'}>
                <SupplementalLinkedFile
                    linkedFiles={featureDetails.linkedFiles}
                    assetType={assetType}
                    assetTypeId={assetTypeId}
                    header={intl.formatMessage({ id: 'supplementaryDataTab.externalResources' })} />
            </div>
            <div key={'guidanceLinkedFiles'} data-testid={'guidanceLinkedFiles'}>
                {featureDetails.guidances?.map(guidanceData =>
                    <SupplementalGuidance
                        key={guidanceData?.systemId}
                        assetType={assetType}
                        assetTypeId={assetTypeId}
                        guidance={guidanceData} />
                )}
            </div>
        </TabPanel>
        : null;
};

SupplementaryDataTab.propTypes = {
    'data-testid': PropTypes.string,
    featureDetails: PropTypes.object,
    assetType: PropTypes.string.isRequired,
    assetTypeId: PropTypes.string.isRequired
};
